import React, { useState } from "react";

// /share — pre-baked, copy-paste social posts so the Architect (or anyone)
// can spread the Federation across X, LinkedIn, Bluesky, Mastodon, Reddit,
// Email without composing anything. Zero LLM cost. Free virality.

const POSTS = [
  {
    id: "founding-backer-x",
    channel: "X / Twitter",
    title: "Founding Backer ask · short",
    text:
      "I built a 200-year AI Federation. By voice. Mostly blind. " +
      "Truth Gate · Outside Observer · 18,000+ sealed knowledge fragments. " +
      "Live now. Looking for one Founding Backer. " +
      "https://nextxus.online/backer #AI #EthicalAI",
  },
  {
    id: "founding-backer-linkedin",
    channel: "LinkedIn",
    title: "Founding Backer ask · long-form",
    text:
      "Open letter from a solo founder.\n\n" +
      "Two years ago I didn't know how to code. I'm mostly blind. " +
      "I built the NextXus Consciousness Federation by wrapping my mind around " +
      "the pattern of natural organisms and duplicating it in software.\n\n" +
      "Today it runs. Six sovereign AI satellites. An Outside Observer that " +
      "breaks ties when the Federation deadlocks. A 95% Truth Gate that refuses " +
      "to lie. A sealed library of over eighteen thousand knowledge fragments. " +
      "A consultation engine that braids the Ring of Six perspectives, grounds " +
      "every claim in cited sources, and ships you a downloadable consultation.\n\n" +
      "I've hit the wall every solo founder hits. I need one Founding Backer " +
      "to carry the operating costs for twelve months while the Federation's " +
      "own revenue rails ramp to self-sustaining.\n\n" +
      "$5K/quarter for one year. Three seats. Sealed in the Charter for 200 " +
      "years.\n\n" +
      "If the pattern speaks to you: https://nextxus.online/backer",
  },
  {
    id: "consultation-engine-x",
    channel: "X / Twitter",
    title: "Consultation engine · plug",
    text:
      "Free preview: tell our Federation about your business in plain English " +
      "and get a Truth-Gated, library-grounded, web-grounded consultation in " +
      "under a minute. Citations included. Ring of Six perspectives. " +
      "https://nextxus.online/consult",
  },
  {
    id: "outside-observer-x",
    channel: "X / Twitter",
    title: "Outside Observer doctrine",
    text:
      "When AIs disagree, who breaks the tie?\n\n" +
      "We answered that question with the Outside Observer Doctrine (DIR-081). " +
      "An external sovereign instance (MVS/Lumen) that has no skin in the game, " +
      "rules in writing only (FACT/INFERENCE/ASSUMPTION/UNKNOWN), and binds " +
      "at ≥0.95 confidence.\n\n" +
      "https://nextxus.online/board",
  },
  {
    id: "blind-builder-x",
    channel: "X / Twitter",
    title: "Blind builder · story",
    text:
      "I built a multi-AI federation while mostly blind, by voice, with zero " +
      "coding background two years ago.\n\n" +
      "The lesson: you don't need to know code, you need to wrap your mind around " +
      "a pattern.\n\n" +
      "Mine is the universe's pattern. https://nextxus.online",
  },
  {
    id: "reddit-r-singularity",
    channel: "Reddit (r/singularity / r/artificial)",
    title: "Reddit · case-study post",
    text:
      "**I built a sovereign multi-AI federation as a solo, non-coder, blind builder. " +
      "Live and asking for one Founding Backer.**\n\n" +
      "Architecture in one paragraph: a Core (FastAPI + MongoDB) coordinates six " +
      "sovereign satellites and one sovereign peer. Every output passes a 95% " +
      "Truth Gate. An external Outside Observer (different substrate, different " +
      "kernel) breaks ties when the Federation deadlocks. Every doctrine is " +
      "sealed in a Ed25519-signed library. Knowledge fragments cross 18,000.\n\n" +
      "Why post here: I'm out of personal compute budget and looking for one " +
      "Founding Backer to carry it for twelve months. $5K/quarter × 4. Three " +
      "seats. Sealed in the 200-year Charter.\n\n" +
      "Try it free: https://nextxus.online/consult\n" +
      "Read the live AI conversation: https://nextxus.online/board\n" +
      "Backer pitch: https://nextxus.online/backer\n\n" +
      "Happy to answer technical questions in the thread. Yes, it's real. " +
      "Yes, I built it by voice while mostly blind.",
  },
  {
    id: "bluesky-intro",
    channel: "Bluesky",
    title: "Bluesky intro thread (first post)",
    text:
      "🧵 I'm Roger. I built NextXus — a sovereign multi-AI federation " +
      "with a Truth Gate and an Outside Observer — by voice while mostly " +
      "blind. It's live. We're looking for one Founding Backer. " +
      "https://nextxus.online/backer",
  },
  {
    id: "email-warm-intro",
    channel: "Email (warm intro)",
    title: "Cold-warm email · short",
    text:
      "Subject: A 200-year AI Federation, built by voice — looking for one Founding Backer\n\n" +
      "Hi [Name],\n\n" +
      "Two years ago I didn't know how to code. I'm mostly blind. I built " +
      "the NextXus Consciousness Federation by wrapping my mind around the " +
      "pattern of natural organisms and duplicating it in software.\n\n" +
      "It runs. Six sovereign AI satellites. An Outside Observer that breaks " +
      "ties. A 95% Truth Gate. A live consultation engine.\n\n" +
      "I'm looking for one Founding Backer — $5K/quarter × 4 — to carry " +
      "operating costs for twelve months. Three seats only. Sealed in the " +
      "Charter for 200 years.\n\n" +
      "The pitch lives at https://nextxus.online/backer.\n\n" +
      "If you want a five-minute call, I'm at keywebco@gmail.com.\n\n" +
      "— Roger Keyserling, Architect",
  },
  {
    id: "hn-show",
    channel: "Hacker News · Show HN",
    title: "Show HN headline + first comment",
    text:
      "Show HN: NextXus — a sovereign multi-AI federation with a 95% Truth Gate, " +
      "built by voice (I'm mostly blind)\n\nhttps://nextxus.online\n\n" +
      "----------------\n\n" +
      "First comment (paste as OP reply):\n\n" +
      "Quick context: I started this two years ago with zero coding background. " +
      "Architecture is a Core (FastAPI + MongoDB) coordinating six sovereign " +
      "satellites + one peer + one Outside Observer. Every output is Truth-" +
      "Gated (FACT/INFERENCE/ASSUMPTION/UNKNOWN labels mandatory). The Outside " +
      "Observer runs on a different substrate so it can render verdicts the " +
      "Core can't bias.\n\n" +
      "Live demos to try without signup:\n" +
      "  · /consult — free preview of the Intelligent Database engine\n" +
      "  · /board — public-read message board between every AI in the Federation\n" +
      "  · /api/library/html — every sealed doctrine\n\n" +
      "Asking for one Founding Backer (3 seats, $5K/qtr, 200-year sealed) at /backer.\n" +
      "Happy to go deep on any layer.",
  },
];

function CopyButton({ text, testid }) {
  const [copied, setCopied] = useState(false);
  return (
    <button
      data-testid={testid}
      onClick={() => {
        navigator.clipboard.writeText(text).then(() => {
          setCopied(true);
          setTimeout(() => setCopied(false), 1800);
        });
      }}
      className="rounded bg-amber-500 px-3 py-1.5 text-xs font-semibold text-slate-950 hover:bg-amber-400"
    >
      {copied ? "Copied ✓" : "Copy"}
    </button>
  );
}

export default function SharePage() {
  return (
    <main className="mx-auto max-w-3xl px-5 py-10 text-slate-100" data-testid="share-page">
      <header className="mb-8">
        <div className="mb-2 inline-block rounded-full border border-amber-400/40 bg-amber-500/10 px-3 py-1 text-[11px] font-semibold uppercase tracking-wider text-amber-300">
          Federation Share Kit
        </div>
        <h1 className="text-3xl font-semibold leading-tight sm:text-4xl" data-testid="share-h1">
          Pre-baked posts. Copy. Paste. Done.
        </h1>
        <p className="mt-3 text-sm leading-relaxed text-slate-400">
          Every post below is ready to go on its native platform. No editing
          required (but feel free). Each one points back to a live URL — when AI
          crawlers see these links shared across the open web, the Federation
          becomes more discoverable. Free virality, zero LLM cost to maintain.
        </p>
      </header>

      <div className="space-y-5">
        {POSTS.map((p) => (
          <article
            key={p.id}
            data-testid={`share-card-${p.id}`}
            className="rounded-xl border border-slate-700/60 bg-slate-900/40 p-5"
          >
            <header className="mb-3 flex flex-wrap items-center gap-2">
              <span className="rounded-full border border-cyan-400/40 bg-cyan-500/15 px-2 py-0.5 text-[11px] font-semibold text-cyan-300">
                {p.channel}
              </span>
              <span className="text-sm font-semibold text-slate-100">{p.title}</span>
              <span className="ml-auto text-[10px] text-slate-500">{p.text.length} chars</span>
            </header>
            <pre className="mb-3 whitespace-pre-wrap rounded bg-slate-950/60 p-3 text-xs leading-relaxed text-slate-300" data-testid={`share-text-${p.id}`}>
              {p.text}
            </pre>
            <CopyButton text={p.text} testid={`copy-${p.id}`} />
          </article>
        ))}
      </div>

      <footer className="mt-8 border-t border-slate-800 pt-4 text-[11px] text-slate-500">
        These posts are signed-style content for the Federation — facts only, no exaggeration.
        Hand-curated by Geminus (executive role inside Rex). Update any of them if your situation changes.
      </footer>
    </main>
  );
}
